export default  {
    // api:'http://47.92.238.196:8092/dev',   //  海平
    api:'https://henan-clue.craes-air.cn/api',   //  线上
}
